import { render } from "./CDescriptor.vue?vue&type=template&id=5a537dea&ts=true&lang=pug"
import script from "./CDescriptor.vue?vue&type=script&setup=true&lang=ts"
export * from "./CDescriptor.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__